import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HaloLoaderService {
  public processCount: number = 0;
  public processChange: EventEmitter<number> = new EventEmitter();

  constructor() {}

  startProcess(processName?: string) {
    this.processCount++;
    this.processChange.emit(this.processCount);

    if (processName) {
      console.log('...', processName);
    }
  }

  endProcess() {
    this.processCount--;

    if (this.processCount === 0) {
      this.processChange.emit(this.processCount);
    } else if (this.processCount < 0) {
      this.processCount = 0;
    }
  }
 // Use startProcess and endProcess for loading, resetProcess is especially to dismissed the loading at all.
  resetProcess(){
    this.processCount = 0;
    this.processChange.emit(this.processCount);
  }
}
